module.exports = __webpack_public_path__ + "img/default-avatar.a46d8ad4.jpg";